import type {
  SetHoveredSectionLikeAction,
  SetIsSectionActionsBarHoveredAction,
} from './sections.actions';
import { sectionsActionTypes } from './sections.actionTypes';

import type { CompRef } from 'types/documentServices';

export const sectionsInitialState: SectionsState = {
  hoveredSectionLikeRef: undefined,
  sectionActionsBarHovered: false,
};

export interface SectionsState {
  hoveredSectionLikeRef: CompRef | undefined;
  sectionActionsBarHovered: boolean;
}

type SectionsAction =
  | SetHoveredSectionLikeAction
  | SetIsSectionActionsBarHoveredAction;

export const sectionsReducer = (
  state = sectionsInitialState,
  action: SectionsAction,
) => {
  switch (action.type) {
    case sectionsActionTypes.SET_HOVERED_SECTION_LIKE_REF:
      return {
        ...state,
        hoveredSectionLikeRef: action.payload,
      };
    case sectionsActionTypes.SET_SECTION_ACTION_BAR_HOVERED:
      return {
        ...state,
        sectionActionsBarHovered: action.payload,
      };
    default:
      return state;
  }
};
